import React from 'react'
import './styles.css'
import SvgIcon, { iconList } from '../../../share/components/iconSVG'

const FirstInfo = ({stars, cities, setModal}) => {
    return (
        <div className='contain-firts-info-specilist'>
            <section className='first-info-specialist-sedes'>
                <ul>
                    <li>
                        <SvgIcon name={iconList.IconPinMapBlank} size={20} color={'#0042749a'} />
                        {cities.length} {cities.length > 1 ? 'sedes' : 'sede'} en{cities.map((item,key)=>{
                            return(
                                <span style={{color:'black'}} key={key}>
                                    {item.city.name}{cities.length > 1 ? ',' : ''} 
                                </span>
                            )
                        })}{cities.length > 1 ? '...' : ''} <span>Ver mas</span>
                    </li>
                    <li>
                        <SvgIcon name={iconList.IconCalendar} size={20} color={'#004274'} />
                        Reservar cita <span onClick={()=>{setModal(true)}}>Ver calendario</span>
                    </li>
                    <li>
                        <SvgIcon name={iconList.IconDoctor} size={20} color={'#004274'} />
                        Responde en mas de 72 horas
                    </li>
                    <li>
                        <SvgIcon name={iconList.IconCheckSucces} size={20} color={'#004274'} />
                        Registro Profesional
                    </li>
                </ul>
            </section>
            <section className='first-info-specialist-rate'>
                <ul className='list-star-first-info'>
                    <li>
                        <SvgIcon name={iconList.IconStar} size={30} color={'#ffff00'} />
                    </li>
                    <li>
                        <SvgIcon name={iconList.IconStar} size={30} color={'#ffff00'} />
                    </li>
                    <li>
                        <SvgIcon name={iconList.IconStar} size={30} color={'#ffff00'} />
                    </li>
                    <li>
                        <SvgIcon name={iconList.IconStar} size={30} color={'#ffff00'} />
                    </li>
                    <li>
                        <SvgIcon name={iconList.IconStar} size={30} color={'#ffff00'} />
                    </li>
                </ul>
                <div className='points-first-info'>
                    <div className='rate-detail-specialist'>
                        <p>{stars}</p>
                    </div>
                    <div>
                        <p style={{color:'#004274', fontWeight:'700'}}>{stars >= 5 ? 'Excelente' : 'Bueno'}</p>
                        <p>Ver comentarios</p>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default FirstInfo